var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 120,
    viewBox: "0 0 224 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_2390)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M224.254 48.3153C224.726 63.6793 213.481 85.2758 201.164 93.885C170.835 115.081 115.827 121.706 71.9836 113.946C71.3198 113.831 70.6751 113.711 70.0257 113.57C69.9445 113.563 69.8586 113.535 69.7773 113.529C63.2158 112.265 56.901 110.556 50.9004 108.341C41.0884 104.727 32.1694 99.8384 24.6418 93.4791C24.3279 93.2209 24.0331 92.9587 23.7384 92.6965C16.5213 86.3879 10.6138 78.6949 6.52833 69.4872C6.2221 68.7879 5.93965 68.1068 5.65721 67.4257C-5.57698 39.2418 9.12409 10.9983 38.2543 7.86452C64.9012 4.99582 73.863 15.057 95.3743 19.5547C116.881 24.0302 142.255 14.6938 163.395 9.48445C170.636 7.69181 178.482 7.83151 183.671 8.27239C202.466 9.91489 223.408 20.7898 224.254 48.3153Z",
    fill: "#4182EC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.005 86.4265L67.3609 74.099C64.853 73.7457 63.1222 71.4144 63.4754 68.9065L72.4474 8.25763C72.8006 5.74973 75.1319 4.01892 77.6398 4.37215L161.284 16.6997C163.792 17.053 165.522 19.3843 165.169 21.8922L156.233 82.5411C155.844 85.0843 153.513 86.8151 151.005 86.4265Z",
    fill: "url(#paint0_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.115 85.7154C153.221 86.0417 155.191 84.5912 155.521 82.4338C155.521 82.4333 155.521 82.4329 155.521 82.4324L164.457 21.7918C164.457 21.7912 164.457 21.7905 164.457 21.7899C164.754 19.6706 163.291 17.7092 161.183 17.4123L161.179 17.4116L77.5394 5.0847C77.5387 5.0846 77.538 5.08449 77.5372 5.08439C75.418 4.7871 73.4568 6.25001 73.1599 8.35799L73.1592 8.36294L64.188 69.0069C64.1879 69.0077 64.1877 69.0086 64.1876 69.0094C63.8905 71.1285 65.3534 73.0895 67.4613 73.3864L67.4658 73.387L151.115 85.7154ZM63.4754 68.9065L72.4474 8.25763C72.8006 5.74973 75.1319 4.01892 77.6398 4.37215L161.284 16.6997C163.792 17.053 165.522 19.3843 165.169 21.8922L156.233 82.5411C155.844 85.0843 153.513 86.8151 151.005 86.4265L67.3609 74.099C64.853 73.7457 63.1222 71.4144 63.4754 68.9065Z",
    fill: "url(#paint1_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.074 79.1083L69.1824 89.6344C66.6745 89.9523 64.3785 88.1508 64.0606 85.6429L56.4309 24.8528C56.113 22.3448 57.9145 20.0489 60.4224 19.731L144.314 9.20484C146.821 8.88694 149.117 10.6884 149.435 13.1963L157.065 74.0218C157.383 76.4944 155.581 78.7904 153.074 79.1083Z",
    fill: "url(#paint2_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1824 89.6344L153.074 79.1083C155.581 78.7904 157.383 76.4944 157.065 74.0218L149.435 13.1963C149.117 10.6884 146.821 8.88694 144.314 9.20484L60.4224 19.731C57.9145 20.0489 56.113 22.3448 56.4309 24.8528L64.0606 85.6429C64.3785 88.1508 66.6745 89.9523 69.1824 89.6344ZM64.7745 85.5528C64.7745 85.5527 64.7745 85.553 64.7745 85.5528C65.0433 87.6713 66.9833 89.1878 69.0919 88.9205L152.983 78.3944C152.983 78.3944 152.983 78.3944 152.983 78.3944C155.105 78.1251 156.617 76.1821 156.351 74.1136L156.351 74.1114L148.721 13.2868C148.453 11.1681 146.513 9.65142 144.404 9.91871L60.5129 20.4448C58.3942 20.7134 56.8775 22.6536 57.1448 24.7623L64.7745 85.5528Z",
    fill: "url(#paint3_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.129 112.444L76.4736 99.8772C74.1634 99.4885 72.5938 96.9631 73.0009 94.2583L82.823 27.5558C83.2301 24.851 85.4489 22.9418 87.7591 23.3306L164.415 35.8975C166.725 36.2862 168.294 38.8117 167.887 41.5165L158.065 108.219C157.658 110.924 155.475 112.798 153.129 112.444Z",
    fill: "url(#paint4_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0009 94.2583C72.5938 96.963 74.1634 99.4885 76.4736 99.8772L153.129 112.444C155.475 112.798 157.658 110.924 158.065 108.219L167.887 41.5165C168.294 38.8117 166.725 36.2862 164.415 35.8975L87.7591 23.3306C85.4489 22.9418 83.2301 24.851 82.823 27.5558L73.0009 94.2583ZM164.25 36.8839C164.25 36.8838 164.249 36.8837 164.249 36.8836L87.5932 24.3167C85.9811 24.0454 84.1605 25.393 83.8121 27.7032C83.8121 27.7037 83.812 27.7042 83.8119 27.7047L73.9898 94.4071C73.6429 96.7119 74.9963 98.614 76.6387 98.891C76.6385 98.8909 76.639 98.891 76.6387 98.891L153.278 111.455C153.28 111.456 153.282 111.456 153.284 111.456C154.952 111.704 156.73 110.367 157.076 108.071C157.076 108.071 157.076 108.07 157.076 108.07L166.898 41.3708L166.898 41.3676C167.245 39.0633 165.892 37.1615 164.25 36.8839Z",
    fill: "url(#paint5_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9781 44.2409L84.6882 32.1958C83.6992 30.8889 82.145 30.1118 80.5908 30.1118H56.5361C53.9576 30.1118 52.0855 32.2312 52.3681 34.8097L53.3571 44.2409L53.3924 44.5941L60.245 109.87C60.5276 112.449 62.8236 114.533 65.4021 114.533H161.02C163.599 114.533 165.471 112.449 165.188 109.87L158.73 53.6692C158.447 51.0907 148.458 44.2409 145.88 44.2409H93.9781Z",
    fill: "url(#paint6_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4727 45.2688L83.8685 32.8162C83.0671 31.7573 81.8121 31.1398 80.5908 31.1398H56.5361C54.5815 31.1398 53.1727 32.7158 53.3899 34.6977L53.3904 34.7025L54.38 44.1386L54.4148 44.4868L54.4153 44.4918L61.2669 109.758C61.2669 109.759 61.267 109.76 61.2671 109.761C61.4947 111.826 63.3576 113.505 65.4021 113.505H161.02C162.985 113.505 164.381 111.955 164.167 109.985C164.167 109.984 164.167 109.983 164.167 109.982L157.708 53.7812C157.701 53.7212 157.636 53.5063 157.361 53.115C157.104 52.7488 156.726 52.3174 156.243 51.8393C155.277 50.8853 153.968 49.8225 152.569 48.8252C151.172 47.8293 149.713 46.9186 148.459 46.2621C147.831 45.9335 147.27 45.6767 146.804 45.5045C146.315 45.3236 146.016 45.2688 145.88 45.2688H93.4727ZM53.3924 44.5941L53.3571 44.2409L52.3681 34.8097C52.0855 32.2312 53.9576 30.1118 56.5361 30.1118H80.5908C82.145 30.1118 83.6992 30.8889 84.6882 32.1958L93.9781 44.2409H145.88C148.458 44.2409 158.447 51.0907 158.73 53.6692L165.188 109.87C165.471 112.449 163.599 114.533 161.02 114.533H65.4021C62.8236 114.533 60.5276 112.449 60.245 109.87L53.3924 44.5941Z",
    fill: "url(#paint7_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_85_2390)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.1514,
    height: 19.3024,
    rx: 3.86048,
    transform: "matrix(-1 0 0 1 74.7109 50.05)",
    fill: "url(#paint8_linear_85_2390)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4199,
    y: 53.9106,
    width: 10.9541,
    height: 10.9541,
    rx: 1.98218,
    fill: "url(#paint9_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3047,
    y: 55.4263,
    width: 15.7651,
    height: 2.72247,
    rx: 0.991088,
    fill: "url(#paint10_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3047,
    y: 60.6265,
    width: 30.5461,
    height: 2.72247,
    rx: 0.991088,
    fill: "url(#paint11_linear_85_2390)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_85_2390)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.1514,
    height: 19.3024,
    rx: 3.86048,
    transform: "matrix(-1 0 0 1 85.1523 72.05)",
    fill: "url(#paint12_linear_85_2390)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.8613,
    y: 75.9106,
    width: 10.9541,
    height: 10.9541,
    rx: 1.98218,
    fill: "url(#paint13_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.7461,
    y: 77.4263,
    width: 15.7651,
    height: 2.72247,
    rx: 0.991088,
    fill: "url(#paint14_linear_85_2390)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.7461,
    y: 82.6265,
    width: 30.5461,
    height: 2.72247,
    rx: 0.991088,
    fill: "url(#paint15_linear_85_2390)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_85_2390",
    x: 21.6297,
    y: 49.0856,
    width: 58.8678,
    height: 27.0179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.92885,
    dy: 2.89328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92885
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.130752 0 0 0 0 0.15853 0 0 0 0 0.219642 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_2390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_85_2390",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_85_2390",
    x: 32.0711,
    y: 71.0856,
    width: 58.8678,
    height: 27.0179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.92885,
    dy: 2.89328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92885
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.130752 0 0 0 0 0.15853 0 0 0 0 0.219642 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_2390"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_85_2390",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_2390",
    x1: 100.388,
    y1: -24.2745,
    x2: 82.0994,
    y2: 112.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202901,
    stopColor: "#A1B3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47265,
    stopColor: "#1D3882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_85_2390",
    x1: 66.4972,
    y1: -0.0444544,
    x2: 131.224,
    y2: 70.2618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6B6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5167A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_85_2390",
    x1: 74.6284,
    y1: -38.3403,
    x2: 89.7752,
    y2: 108.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142989,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373896,
    stopColor: "#E4EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592959,
    stopColor: "#4F71D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_85_2390",
    x1: 165.135,
    y1: 10.7614,
    x2: 106.843,
    y2: 74.5801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DADDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408204,
    stopColor: "#CFD6E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_85_2390",
    x1: 97.2779,
    y1: 17.32,
    x2: 85.6034,
    y2: 131.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430736,
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_85_2390",
    x1: 172.825,
    y1: 26.7505,
    x2: 118.875,
    y2: 77.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_85_2390",
    x1: 121.896,
    y1: 109.219,
    x2: 66.8851,
    y2: 33.0309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164324,
    stopColor: "#122D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690489,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_85_2390",
    x1: 52.3398,
    y1: 27.6657,
    x2: 164.141,
    y2: 100.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EBDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377456,
    stopColor: "#405EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234194"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_85_2390",
    x1: 18.573,
    y1: -6.71986,
    x2: 36.142,
    y2: 31.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724203,
    stopColor: "#B3C0E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_85_2390",
    x1: 35.0643,
    y1: 74.6812,
    x2: 1.58567,
    y2: 62.5432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58194,
    stopColor: "#C3CDEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_85_2390",
    x1: 51.3064,
    y1: 60.5884,
    x2: 41.2256,
    y2: 39.4238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#D5DEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_85_2390",
    x1: 61.6213,
    y1: 65.7886,
    x2: 55.6019,
    y2: 41.3021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#D5DEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_85_2390",
    x1: 18.573,
    y1: -6.71986,
    x2: 36.142,
    y2: 31.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724203,
    stopColor: "#B3C0E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_85_2390",
    x1: 45.5057,
    y1: 96.6812,
    x2: 12.0271,
    y2: 84.5432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608161,
    stopColor: "#C2CDEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_85_2390",
    x1: 61.7478,
    y1: 82.5884,
    x2: 51.667,
    y2: 61.4238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#BAC6E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_85_2390",
    x1: 72.0628,
    y1: 87.7886,
    x2: 66.0433,
    y2: 63.3021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936003,
    stopColor: "#BAC6E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_2390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.704adc45715ea2d568f14b98a23b9009.svg";
export { ForwardRef as ReactComponent };